module.exports = __webpack_public_path__ + "media/images/flags/16/Hong-Kong-68f2f47865e414466c150266618855ad.png";